module.exports = __webpack_public_path__ + "img/40_47.52cf0e5e.png";